import $ from 'jquery';

const $body = $('body');
const inBackend = $body.hasClass('neos-backend');

$(function () {

    if (inBackend) return;

    $('.timeline-block').each(function () {

        const $element = $(this);

        const $contentContainer = $element.find('.timeline-content');
        const $items = $contentContainer.find('.timeline-item');

        // Drag last element out of the container to stop the line and dot at the end
        $element.append($items.last());

    });


});
